import VCalendar from 'v-calendar'
import 'v-calendar/style.css'

import {VMain} from 'vuetify/components/VMain'
import {VCol, VContainer, VRow, VSpacer} from 'vuetify/components/VGrid'
import {VSheet} from 'vuetify/components/VSheet'
import {VBtnToggle} from 'vuetify/components/VBtnToggle'
import {VCard} from 'vuetify/components/VCard'
import {VAppBar} from 'vuetify/components/VAppBar'
import {VApp} from 'vuetify/components/VApp'
import {VBtn} from 'vuetify/components/VBtn'
import {VSwitch} from 'vuetify/components/VSwitch'
import {VFooter} from 'vuetify/components/VFooter'
import {VForm} from 'vuetify/components/VForm'
import {VTextField} from 'vuetify/components/VTextField'
import {VBreadcrumbs} from 'vuetify/components/VBreadcrumbs'
import {VNumberInput} from 'vuetify/labs/VNumberInput'
import {VTooltip} from 'vuetify/components/VTooltip'
import {VTabs} from 'vuetify/components/VTabs'
import {VCombobox} from 'vuetify/components/VCombobox'
import {VRadioGroup} from 'vuetify/components/VRadioGroup'
import {VFileUpload, VFileUploadItem} from 'vuetify/labs/VFileUpload'

import ClientOnlyDialog from '~/components/ClientOnlyDialog.vue'

export default defineNuxtPlugin(() => {
    const app = useNuxtApp()

    // TODO [P1] need change font settings as abbey mod
    const ssr = app.$device.isMobileOrTablet || {clientWidth: 961} // the desired width for initial render. This is a 'md' breakpoint width // or try 1281

    app.hook('vuetify:before-create', ({vuetifyOptions}) => {
        Object.assign(vuetifyOptions, {
            ssr,
            components: {
                VMain,
                VCol,
                VContainer,
                VRow,
                VSpacer,
                VSheet,
                VCard,
                VAppBar,
                VApp,
                VBtn,
                VFooter,
                VForm,
                VTextField,
                VNumberInput,
                VFileUpload,
                VFileUploadItem,
                VSwitch,
                VBreadcrumbs,
                VTooltip,
                VRadioGroup,
                VTabs,
                VCombobox,
                VBtnToggle,
                ...(process.env.NODE_ENV === 'production' && {VDialog: ClientOnlyDialog}),
            },
            defaults: {
                VCombobox: {
                    color: 'primary',
                    variant: 'outlined',
                    density: 'comfortable',
                    VChip: {
                        color: 'primary',
                    },
                },
                VCarousel: {
                    VBtn: {
                        color: 'default',
                    },
                },
                VTabs: {
                    color: 'primary',
                    sliderColor: 'primary',
                },
                VTooltip: {
                    location: 'bottom',
                },
                VTextField: {
                    density: 'comfortable',
                    variant: 'outlined',
                    color: 'primary',
                },
                VBtnToggle: {
                    density: 'comfortable',
                    variant: 'outlined',
                },
                VNumberInput: {
                    density: 'comfortable',
                    variant: 'outlined',
                    color: 'primary',
                    controlVariant: 'stacked',
                    VBtn: {
                        color: 'default',
                    },
                },
                VSelect: {
                    density: 'comfortable',
                    variant: 'outlined',
                    color: 'primary',
                },
                VAutocomplete: {
                    density: 'comfortable',
                    variant: 'outlined',
                    color: 'primary',
                },
                VTextarea: {
                    density: 'comfortable',
                    variant: 'outlined',
                    color: 'primary',
                },
                VFileInput: {
                    density: 'comfortable',
                    variant: 'outlined',
                    color: 'primary',
                },
                VDialog: {
                    scrollStrategy: 'none',
                },
                VExpansionPanels: {
                    flat: true,
                },
                VRangeSlider: {
                    thumbSize: 12,
                    color: 'primary',
                    trackSize: 1,
                },
                VSlider: {
                    thumbSize: 12,
                    color: 'primary',
                    trackSize: 1,
                },
                VCheckbox: {
                    color: 'primary',
                    density: 'compact',
                },
                VCheckboxBtn: {
                    color: 'primary',
                    density: 'compact',
                },
                VRadioGroup: {
                    color: 'primary',
                    density: 'compact',
                },
                VBtn: {
                    elevation: '0',
                    variant: 'flat',
                    color: 'primary',
                },
                VSwitch: {
                    color: 'primary',
                },
            },
            icons: {
                aliases: iconAliases,
            },
        })
    })

    const breakpoint = new Proxy(
        {},
        {
            get: (target, prop) => {
                return app.$vuetify?.display[prop].value
            },
        }
    )

    app.vueApp.use(VCalendar, {
        componentPrefix: 'vc',
        locales: {
            sq: {
                firstDayOfWeek: 2,
            },
        },
    })

    return {provide: {breakpoint}}
})
